import { RemarkStyleGeneratedEntity } from "./generated/RemarkStyleGeneratedEntity";

export abstract class RemarkStyleEntity extends RemarkStyleGeneratedEntity {
    // Comment to preserve new line
}
